import React from 'react';
import { Box } from '@mui/material';

const MONO = "'IBM Plex Mono', monospace";

// A bordered panel card with optional title-block header bar (mirrors a real drawing's title block).
// Props:
//   label      — mono uppercase label (e.g. "DRAWING REGISTER")
//   dotColor   — status dot color (default teal)
//   rightSlot  — optional right-aligned content in the header
//   footer     — optional footer content
//   children   — body content
//   sx         — sx override for outer box
export default function PanelCard({ label, dotColor = '#2dd4bf', rightSlot, footer, children, sx = {} }) {
  return (
    <Box
      sx={{
        position: 'relative',
        border: '1px solid rgba(120,150,200,.22)',
        borderRadius: '14px',
        background: 'linear-gradient(180deg,#0e1c39,#0a1326)',
        boxShadow: '0 24px 60px rgba(0,0,0,.3)',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {label && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: '18px',
            py: '13px',
            borderBottom: '1px solid rgba(120,150,200,.18)',
            background: 'rgba(8,15,30,.5)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: '9px', fontFamily: MONO, fontSize: '11.5px', letterSpacing: '.1em', color: '#90a6cc' }}>
            <Box sx={{ width: 8, height: 8, borderRadius: '50%', background: dotColor, flexShrink: 0 }} />
            {label}
          </Box>
          {rightSlot && (
            <Box sx={{ fontFamily: MONO, fontSize: '11px', color: '#5f7398' }}>
              {rightSlot}
            </Box>
          )}
        </Box>
      )}

      {children}

      {footer && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: '20px',
            py: '11px',
            borderTop: '1px solid rgba(120,150,200,.16)',
            background: 'rgba(8,15,30,.4)',
            fontFamily: MONO,
            fontSize: '10.5px',
            letterSpacing: '.1em',
            color: '#4f648a',
          }}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
}
